import {ImportPlanSectionProps} from './import/import-plan-sections/ImportPlanSection';
import {LogLevel} from './migration-log/LogLevel';
import {MigrationStep} from './types/MigrationStep';

export interface TemplateAttributes {
  templateCollectionId: string;
  processTaskSchemaId: string | null;
}

export interface UnitAttributes {
  unitTypeId: string;
}

export interface ProcessOutputSchemaAttributes {
  processTaskSchemaId: string;
}

export interface ProcessFlowchartConfigAttributes {
  processTaskSchemaId: string;
}

export type MigrationObjectAttributes =
  | {}
  | TemplateAttributes
  | ProcessOutputSchemaAttributes
  | ProcessFlowchartConfigAttributes;

/**
 * An interface for the information needed to display the configuration options for a section
 * of objects within an Import tab, including information on each object's planning options.
 *
 * These are the various sections of objects colocated on a single tab of the Import Wizard.
 *
 * These are passed directly to the ImportPlan to have planComponent property rendered in the UI.
 */
export interface MigrationPlanSection {
  sectionDisplayName: string;
  collapsed: boolean;
  objectIds: Array<string>;
  index: number;
  planComponent: (props: ImportPlanSectionProps) => JSX.Element;
  migrationTab: MigrationStep;
}

// Keep in sync with benchling/config_migration/response_objects/export/migration_export_log_detail_response_json.py
export interface MigrationError {
  message: string;
  level: LogLevel;
}

// Keep in sync with benchling/config_migration/importer/validation/constants.py
export enum UnattributedErrorSource {
  UNKNOWN = 'UNKNOWN',
  SCHEMAS_PRODUCT_LIMIT = 'SCHEMAS_PRODUCT_LIMIT',
  TEMPLATES_PRODUCT_LIMIT = 'TEMPLATES_PRODUCT_LIMIT',
}

export enum MigrationStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export enum HighImpactFieldNames {
  REQUIRED = 'is_required',
  ARCHIVED = 'archive_reason',
}

export enum HighImpactObjectClass {
  FIELDSET_CONFIG = 'FieldsetConfig',
}

export enum HighImpactChange {
  REQUIRED = 'REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  ARCHIVED = 'ARCHIVED',
  NOT_ARCHIVED = 'NOT_ARCHIVED',
  DROPDOWN_UPDATE = 'DROPDOWN_UPDATE',
  FIELDSET = 'FIELDSET',
  REMOVED = 'REMOVED',
}
